.a0{overflow:hidden;}